(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fm-hero-slideshow')) {
    customElements.define('fm-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };

        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.editing = false;

        this.querySelector('[data-prev]')?.addEventListener(
          'click',
          () => this.show(this.index - 1),
          options
        );

        this.querySelector('[data-next]')?.addEventListener(
          'click',
          () => this.show(this.index + 1),
          options
        );

        this.dots.forEach(dot => {
          dot.addEventListener(
            'click',
            () => this.show(Number(dot.dataset.dot)),
            options
          );
        });

        const pause = this.querySelector('[data-pause]');

        if (pause) {
          pause.textContent = this.userPaused ? 'Reanudar' : 'Pausar';

          pause.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            pause.textContent = this.userPaused ? 'Reanudar' : 'Pausar';
          }, options);
        }

        this.addEventListener('mouseenter', () => {
          this.hovered = true;
        }, options);

        this.addEventListener('mouseleave', () => {
          this.hovered = false;
        }, options);

        this.addEventListener('touchstart', event => {
          this.touch = event.touches.length === 1
            ? {
                x: event.touches[0].clientX,
                y: event.touches[0].clientY
              }
            : null;
        }, { ...options, passive: true });

        this.addEventListener('touchend', event => {
          if (!this.touch || !event.changedTouches.length) return;

          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          this.touch = null;

          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 2) {
            this.suppressClickUntil = Date.now() + 400;
            this.show(this.index + (dx < 0 ? 1 : -1));
          }
        }, { ...options, passive: true });

        this.addEventListener('touchcancel', () => {
          this.touch = null;
        }, { ...options, passive: true });

        this.addEventListener('click', event => {
          if (Date.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { ...options, capture: true });

        document.addEventListener(
          'visibilitychange',
          () => this.syncVideos(),
          options
        );

        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;

          const index = this.slides.findIndex(
            slide => slide.dataset.block === event.detail.blockId
          );

          if (index >= 0) {
            this.editing = true;
            this.show(index);
          }
        }, options);

        document.addEventListener('shopify:block:deselect', () => {
          this.editing = false;
        }, options);

        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncVideos();
        }, { threshold: 0.1 });

        this.observer.observe(this);

        if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
          this.timer = setInterval(() => {
            if (
              this.inView &&
              !document.hidden &&
              !this.userPaused &&
              !this.hovered &&
              !this.editing &&
              !this.matches(':focus-within')
            ) {
              this.show(this.index + 1);
            }
          }, Number(this.dataset.delay) || 5000);
        }
      }

      show(index) {
        if (!this.slides.length) return;

        this.index = (index + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });

        this.dots.forEach((dot, i) => {
          dot.setAttribute('aria-current', String(i === this.index));
        });

        this.syncVideos();
      }

      syncVideos() {
        this.slides.forEach((slide, i) => {
          const video = slide.querySelector('video');
          if (!video) return;

          if (i === this.index && this.inView && !document.hidden) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        clearInterval(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
